// Given a number return that number with a suffix
export const getNumberWithOrdinal = (number) => {
  const suffix = ['th', 'st', 'nd', 'rd'];
  const value = number % 100;
  return number + (suffix[(value - 20) % 10] || suffix[value] || suffix[0]);
};
